export const CHAT_VISIBILITY_LIMIT_SCOPES = [
  "chat.block_others",
  "chat.block_queue",
  "chat.block_bots",
];

export const CHAT_VISIBILITY_LIMIT_ACTIONS = new Set(
  CHAT_VISIBILITY_LIMIT_SCOPES.map((scope) => scope.split(".")[1])
);

export const CHAT_VISIBILITY_LIMITS = [
  {
    action: "block_others",
    scope: "chat.block_others",
    label: "Bloquear outros",
    help: "Esconde solicitações de outros atendentes — vê só as suas.",
  },
  {
    action: "block_queue",
    scope: "chat.block_queue",
    label: "Bloquear fila",
    help: "Esconde a fila sem responsável.",
  },
  {
    action: "block_bots",
    scope: "chat.block_bots",
    label: "Bloquear bots/IA",
    help: "Esconde conversas de ChatBots e Agentes de IA.",
  },
];

export function isChatVisibilityLimitScope(scope) {
  return CHAT_VISIBILITY_LIMIT_SCOPES.includes(String(scope || ""));
}

export function isChatVisibilityLimitAction(action) {
  return CHAT_VISIBILITY_LIMIT_ACTIONS.has(String(action || ""));
}

function toScopeSet(scopes) {
  return new Set((Array.isArray(scopes) ? scopes : scopes instanceof Set ? [...scopes] : []).map(String));
}

/** Editor sem esse limite (ou master) pode ligar/desligar. */
export function canEditChatVisibilityLimit(scope, { isMaster = false, actorScopes = [] } = {}) {
  if (isMaster) return true;
  if (!isChatVisibilityLimitScope(scope)) return false;
  return !toScopeSet(actorScopes).has(String(scope));
}

/**
 * Impede escalada: quem tem o limite não consegue tirá-lo.
 * Create: cargo novo herda os limites que o autor sofre.
 * Update: limites já existentes no cargo e sofridos pelo autor permanecem.
 */
export function applyChatVisibilityLimits({
  incomingScopes = [],
  existingScopes = [],
  isCreate = false,
  actorScopes = [],
  isMaster = false,
} = {}) {
  const incoming = toScopeSet(incomingScopes);
  const existing = toScopeSet(existingScopes);
  const actor = toScopeSet(actorScopes);
  for (const scope of CHAT_VISIBILITY_LIMIT_SCOPES) {
    if (isMaster || !actor.has(scope)) continue;
    if (isCreate || existing.has(scope)) incoming.add(scope);
  }
  return Array.from(incoming);
}
